import React from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import EssentialsInfos from './essentialInfos/essentialsInfos'
import OfferTools from './tools'
import Wrapper from '../../ui/wrapper'
import type { Offer } from './mapper'
import EssentialsInfosForCareerSite from './essentialInfos/essentialsInfosForCareerSite'

export type InfosProps = {
  infos: Offer | null
  color: string | null
}

const Infos: React.FC<InfosProps> = ({ infos, color }) => (
  <Wrapper>
    {infos &&
      (color ? (
        <EssentialsInfosForCareerSite data={infos} color={color} />
      ) : (
        <EssentialsInfos data={infos} color="primary" bgColor="blue" />
      ))}
    {infos?.tools && (
      <OfferTools
        tools={
          infos?.tools as {
            name: string | null
            logo: string | IGatsbyImageData | null
            logoUrl: string | null
            slug: string | null
          }[]
        }
      />
    )}
  </Wrapper>
)

export default Infos
